import { DataLayer } from "@grandvisionhq/analytics";
const eventName = "try_on_in_store_click";
const siteFeature = "try_on_in_store";
const pushTryOnInStoreEvent = (event) => {
  const { interactionType, items } = event;
  DataLayer.pushEvent({
    event: eventName,
    site_feature: siteFeature,
    interaction_type: interactionType,
    ...items ? { items } : null
  });
};
export {
  eventName,
  pushTryOnInStoreEvent,
  siteFeature
};
//# sourceMappingURL=try-on-in-store.js.map
